/* Force the header into the theme's own "drawer" layout at every
   screen width and in every language.

   Why this is safe: 'drawer' is a mode the theme already supports and
   styles itself (it is what phones and touch devices get). We only ask
   for that mode -- we do not fight the overflow component or override
   the header grid, which is what broke the header previously.

   Result: hamburger on the left, centred logo, account + cart on the
   right, and every menu link inside the drawer. Identical in EN / FR / ES,
   so the "Plus" / "Mas" overflow button never appears. */

(function () {
  function force() {
    var header = document.querySelector('#header-component');
    if (!header) return;
    // Guard against a loop: only write when the value actually differs.
    if (header.dataset.menuStyle !== 'drawer') {
      header.dataset.menuStyle = 'drawer';
    }
  }

  function start() {
    var header = document.querySelector('#header-component');
    if (!header) return;

    force();

    // The theme recalculates this attribute on load and on resize,
    // so re-assert it whenever it changes.
    new MutationObserver(force).observe(header, {
      attributes: true,
      attributeFilter: ['data-menu-style'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Shopify re-renders sections inside the theme editor.
  document.addEventListener('shopify:section:load', start);
})();
